import { Trans } from 'react-i18next';
import React from 'react';

import { Text } from 'components/library';

import * as S from './styled';

import { ISubscriptionCardHeader } from '../types';

const SubscriptionCardHeader = ({ Icon, heading, isExpired }: ISubscriptionCardHeader) => {
  return (
    <S.SubscriptionCardHeader $isExpired={isExpired}>
      <S.Name>
        <Icon />
        <Text type="medium-text" color={isExpired ? 'text-secondary-subdued' : 'text-main'}>
          <Trans>{heading}</Trans>
        </Text>
      </S.Name>
    </S.SubscriptionCardHeader>
  );
};

export default SubscriptionCardHeader;
